import _get from "lodash";
const VehicleParser = {};

VehicleParser.getVehicleParser = (res) => {
  if (res) {
    return res.result.data;
  }
  if (!res) {
    return {};
  }
  // page, limit, manufacturer, manufacturer_type ,sub_type,variant_name,ac_name, dc_name,model_name

  const parseVehicledata = (t) =>
    t?.map((e) => ({
      page: _get(e, "page", ""),
      limit: _get(e, "limit", ""),
      name: _get(e, "name", ""),
      sub_type: _get(e, "sub_type", ""),
      battery_capacity: _get(e, "battery_capacity", ""),
      manufacturer_id: _get(e, "manufacturer_id", ""),
      manufacturer_name: _get(e, "manufacturer_name", ""),
      model_name: _get(e, "model_name", ""),
      type: _get(e, "type", ""),
      ac: _get(e, "ac", ""),
      dc: _get(e, "dc", ""),
      created_at: _get(e,'created_at'),
      filters: filterParse(res.filters ? res.filters : ""),
    }));
  const filterParse = (t) =>
    t.map((e) => ({
      brands: e.brands ? e.brands : "",
      evTypes: e.evTypes ? e.evTypes : "",
      subTypes: e.subTypes ? e.subTypes : "",
      models: e.models ? e.models : "",
      variants: e.variants ? e.variants : "",
      ac: e.ac ? e.ac : "",
      dc: e.dc ? e.dc : "",
    }));

  const data = parseVehicledata(res);
  return data
};

VehicleParser.getVehicleDropdownData = (res) => {
  if (res) {
  
    return res;
  }

  if (!res) {
    return {};
  }
};

VehicleParser.postVehilceParse = (res) => {
  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};
VehicleParser.postVehilceBuikParse = (res) => {
  if (res) {
    res = res.result;
  }

  if (!res) {
    return {};
  }
};
export { VehicleParser };
